export const as = {
    'brand.mark': 'NK',
    'brand.name': 'নিউজ টাইম',
    'brand.tagline': 'অসমৰ কথা',
    'nav.home': 'মূল পৃষ্ঠা',
    'nav.state': 'ৰাজ্য',
    'nav.national': 'দেশ',
    'nav.local': 'স্থানীয়',
    'nav.sports': 'ক্ৰীড়া',
    'nav.health': 'স্বাস্থ্য',
    'nav.jobs': 'নিযুক্তি',
    'nav.entertainment': 'বিনোদন',
    'nav.videos': "ভিডিঅ'",
    'nav.menu': 'মেনু',
    'nav.close': 'বন্ধ কৰক',
    'ticker.label': 'ব্ৰেকিং',
    'ticker.quiet': 'এতিয়া কোনো ব্ৰেকিং নিউজ নাই।',
    'action.liveTv': 'লাইভ টিভি',
    'action.readFullStory': 'সম্পূৰ্ণ বাতৰি পঢ়ক',
    'action.viewAll': 'সকলো চাওক',
    'action.viewAllNews': 'সকলো বাতৰি চাওক',
    'action.viewAllTrending': 'সকলো চৰ্চিত বাতৰি চাওক',
    'action.viewAllUpdates': 'সকলো আপডেট চাওক',
    'action.search': 'সন্ধান কৰক',
    'action.share': 'ভাগ কৰক',
    'action.retry': 'পুনৰ চেষ্টা কৰক',
    'action.backToTop': 'ওপৰলৈ যাওক',
    'action.switchLanguage': 'Read in English',
    'section.featured': 'বিশেষ',
    'section.topStory': 'শীৰ্ষ বাতৰি',
    'section.categories': 'বিভাগ অনুসৰি চাওক',
    'section.latest': 'শেহতীয়া আৰু গুৰুত্বপূৰ্ণ',
    'section.trending': 'এতিয়া চৰ্চাত',
    'section.liveUpdates': 'লাইভ আপডেট',
    'section.videos': "ভিডিঅ'",
    'video.indexBlurb': 'NK নিউজ টাইমৰ প্ৰতিবেদন, সাক্ষাৎকাৰ আৰু শ্বৰ্টছ।',
    'video.filterLabel': 'শ্ৰেণী অনুসৰি ভিডিঅ’ বাছনি কৰক',
    'video.shorts': 'শ্বৰ্টছ',
    'video.short': 'শ্বৰ্ট',
    'video.related': 'আৰু ভিডিঅ',
    'video.fromStory': 'এই বাতৰিৰ পৰা',
    'video.none': 'ইয়াত এতিয়ালৈকে কোনো ভিডিঅ নাই।',
    'video.unavailable': 'এই ভিডিঅটো আৰু উপলব্ধ নহয়।',
    'video.watchOnArticle': 'চাওক',
    'section.videoCoverage': 'ভিডিঅো সংবাদ',
    'section.culture': 'সংস্কৃতি',
    'newsletter.title': 'বাতৰিৰ লগত থাকক',
    'newsletter.body': 'শেহতীয়া বাতৰিৰ আপডেট পোনপটীয়াকৈ আপোনাৰ ইনবক্সত লাভ কৰক।',
    'newsletter.placeholder': 'আপোনাৰ ই-মেইল ঠিকনা লিখক',
    'newsletter.submit': 'সদস্য হওক',
    'meta.readTime': '{minutes} মিনিটৰ পাঠ',
    'meta.justNow': 'এইমাত্ৰ',
    'meta.advertisement': 'বিজ্ঞাপন',
    'footer.quickLinks': 'দ্ৰুত সংযোগ',
    'footer.categories': 'বিভাগসমূহ',
    'footer.localNews': 'স্থানীয় বাতৰি',
    'footer.legal': 'আইনী',
    'footer.contact': 'যোগাযোগ কৰক',
    'footer.rights': 'সৰ্বস্বত্ব সংৰক্ষিত।',
    'footer.madeIn': 'অসমত ❤ৰে নিৰ্মিত',
    'error.notFoundTitle': 'পৃষ্ঠা পোৱা নগ‌ল',
    'error.notFoundBody': 'আপুনি বিচৰা পৃষ্ঠাটো স্থানান্তৰ হৈছে বা আৰু নাই।',
    'error.genericTitle': 'কিবা এটা ভুল হৈছে',
    'error.genericBody': 'অনুগ্ৰহ কৰি অলপ পিছত পুনৰ চেষ্টা কৰক।',
    'error.offline': 'আপুনি অফলাইন আছে। শেহতীয়াকৈ লোড হোৱা বিষয়বস্তু দেখুওৱা হৈছে।',
    'action.loadMore': 'আৰু চাওক',
    'action.previous': 'পূৰ্বৱৰ্তী',
    'action.next': 'পৰৱৰ্তী',
    'action.skipToContent': 'মূল বিষয়বস্তুলৈ যাওক',
    'search.title': 'সন্ধান',
    'search.placeholder': 'বাতৰি সন্ধান কৰক…',
    'share.copyLink': 'লিংক কপি কৰক',
    'share.copied': 'লিংক কপি হ’ল',
    'status.loading': 'লোড হৈ আছে…',
    'status.comingIn': 'এই অংশটো {phase} নং পৰ্যায়ত পূৰণ কৰা হ’ব।',
    'footer.about': 'আমাৰ বিষয়ে',
    'footer.privacy': 'গোপনীয়তা নীতি',
    'footer.terms': 'ব্যৱহাৰৰ চৰ্তাৱলী',
    'footer.advertise': 'বিজ্ঞাপন দিয়ক',
    'action.previousSlide': 'পূৰ্বৱৰ্তী বাতৰি',
    'action.nextSlide': 'পৰৱৰ্তী বাতৰি',
    'action.play': 'ভিডিঅ’ চাওক',
    'filter.all': 'সকলো',
    'empty.noStories': 'ইয়াত এতিয়ালৈকে কোনো বাতৰি নাই।',
    'live.now': 'লাইভ',
    'live.none': 'এতিয়া কোনো লাইভ কভাৰেজ নাই।',
    'live.updateCount': '{count} টা আপডেট',
    'live.statusScheduled': 'সোনকালে আৰম্ভ হ’ব',
    'live.statusLive': 'লাইভ',
    'live.statusEnded': 'কভাৰেজ শেষ',
    'live.statusArchived': 'আৰ্কাইভ',
    'live.startsAt': '{time}ত আৰম্ভ হ’ব',
    'live.startedAt': '{time}ত আৰম্ভ হৈছে',
    'live.endedAt': '{time}ত শেষ হৈছে',
    'live.timeline': 'আপডেটসমূহ',
    'live.keyUpdate': 'মুখ্য আপডেট',
    'live.newUpdates': '{count} টা নতুন আপডেট',
    'live.newUpdate': '১ টা নতুন আপডেট',
    'live.olderUpdates': 'পুৰণি আপডেট',
    'live.noUpdates': 'এতিয়ালৈকে কোনো আপডেট নাই। আহিলেই ইয়াত দেখা পাব।',
    'live.readMore': 'সম্পূৰ্ণ বাতৰি পঢ়ক',
    'realtime.reconnecting': 'পুনৰ সংযোগ কৰি আছে…',
    'realtime.polling': 'লাইভ সংযোগ বিচ্ছিন্ন — ৩০ ছেকেণ্ডত এবাৰ চোৱা হৈছে',
    'article.breaking': 'ব্ৰেকিং নিউজ',
    'share.more': 'শ্বেয়াৰৰ অন্য উপায়',
    'action.print': 'প্ৰিণ্ট কৰক',
    'action.bookmark': 'সাঁচি থওক',
    'article.related': 'সম্পৰ্কিত বাতৰি',
    'article.moreFromAuthor': 'এই সংবাদদাতাৰ আন বাতৰি',
    'article.updated': '{date}ত সংশোধিত',
    'search.category': 'বিভাগ',
    'search.district': 'জিলা',
    'search.filters': 'ফিল্টাৰ',
    'search.author': 'লেখক',
    'search.dateRange': 'তাৰিখৰ পৰিসৰ',
    'search.dateFrom': 'পৰা',
    'search.dateTo': 'লৈ',
    'search.sort': 'সজাওক',
    'search.sort.relevance': 'প্ৰাসংগিকতা',
    'search.sort.newest': 'নতুনকৈ প্ৰকাশিত',
    'search.sort.most_viewed': 'সৰ্বাধিক পঠিত',
    'search.recent': 'শেহতীয়া সন্ধান',
    'search.clearRecent': 'মচক',
    'search.clearFilters': 'ফিল্টাৰ আঁতৰাওক',
    'search.resultCount': '“{query}”ৰ বাবে {count} টা ফলাফল',
    'search.emptyTitle': '“{query}”ৰ বাবে একো পোৱা নগ‌ল',
    'search.emptyBody': 'কম শব্দ ব্যৱহাৰ কৰি বা অন্য বানানেৰে চেষ্টা কৰক।',
    'search.promptTitle': 'NK নিউজ টাইমত সন্ধান কৰক',
    'search.promptBody': 'এটা-দুটা শব্দ লিখক — শিৰোনাম, টেগ আৰু বাতৰিৰ বিষয়বস্তু সকলোতে বিচৰা হ’ব।',
    'footer.blurb': 'অসমৰ কথা — অসম, ভাৰত আৰু বিশ্বৰ পৰা বাতৰি।',
    // --- Admin CMS (Phase 14) ---------------------------------------------------
    'admin.brand': 'নিউজৰুম',
    'admin.dashboard': 'ডেশ্বব’ৰ্ড',
    'admin.content': 'কণ্টেণ্ট',
    'admin.articles': 'বাতৰিসমূহ',
    'admin.media': 'মিডিয়া',
    'admin.videos': 'ভিডিঅ’',
    'admin.editorial': 'সম্পাদকীয়',
    'admin.homepage': 'হোমপেজ',
    'admin.breaking': 'ব্ৰেকিং নিউজ',
    'admin.live': 'লাইভ কভাৰেজ',
    'admin.taxonomy': 'শ্ৰেণীবিভাজন',
    'admin.categories': 'শ্ৰেণীসমূহ',
    'admin.districts': 'জিলাসমূহ',
    'admin.tags': 'টেগসমূহ',
    'admin.authors': 'লেখকসকল',
    'admin.administration': 'প্ৰশাসন',
    'admin.users': 'ব্যৱহাৰকাৰী',
    'admin.settings': 'ছেটিংছ',
    'admin.auditLog': 'অডিট লগ',
    'admin.quickCreate': 'নতুন',
    'admin.newArticle': 'নতুন বাতৰি',
    'admin.newBreaking': 'নতুন ব্ৰেকিং',
    'admin.newVideo': 'নতুন ভিডিঅ’',
    'admin.commandHint': 'বিচাৰক বা যাওক…',
    'admin.commandPlaceholder': 'বাতৰিৰ শিৰোনাম বা স্ক্ৰীনৰ নাম লিখক',
    'admin.commandScreens': 'স্ক্ৰীন',
    'admin.commandArticles': 'বাতৰি',
    'admin.commandEmpty': 'একো পোৱা নগ’ল।',
    'admin.signedInAs': 'লগ ইন কৰি আছে',
    'admin.viewSite': 'ছাইট চাওক',
    'admin.logout': 'লগ আউট',
    'admin.language': 'CMS ৰ ভাষা',
    'admin.greeting': 'আদৰণি, {name}',
    'admin.statArticles': 'বাতৰি',
    'admin.statPublishedToday': 'আজি প্ৰকাশিত',
    'admin.statDrafts': 'ড্ৰাফ্ট',
    'admin.statPendingReview': 'পৰ্যালোচনাৰ অপেক্ষাত',
    'admin.statBreaking': 'সক্ৰিয় ব্ৰেকিং',
    'admin.statLive': 'লাইভ ইভেণ্ট',
    'admin.statArticleViews': 'বাতৰি পঠন',
    'admin.statVideoViews': 'ভিডিঅ’ দৰ্শন',
    'admin.statVideos': 'প্ৰকাশিত ভিডিঅ’',
    'admin.statSubscribers': 'গ্ৰাহক',
    'admin.statCreatives': 'সক্ৰিয় বিজ্ঞাপন',
    'admin.queueReview': 'পৰ্যালোচনাৰ অপেক্ষাত',
    'admin.queueMine': 'আপোনাৰ ডেস্ক',
    'admin.queueEmptyReview': 'পৰ্যালোচনাৰ বাবে একো নাই।',
    'admin.queueEmptyMine': 'আপোনাৰ ডেস্কত এতিয়ালৈকে একো নাই — এটা বাতৰি আৰম্ভ কৰক।',
    'admin.tickerNow': 'এতিয়া টিকাৰত',
    'admin.tickerEmpty': 'টিকাৰত একো নাই।',
    'admin.untilExpiry': '{time} লৈ',
    'admin.noExpiry': 'শেষৰ সময় নাই',
    'admin.searchTable': 'বিচাৰক',
    'admin.columns': 'স্তম্ভ',
    'admin.selected': '{count} টা বাছনি কৰা হৈছে',
    'admin.clearSelection': 'আঁতৰাওক',
    'admin.rowsPerPage': 'শাৰী',
    'admin.pageOf': 'পৃষ্ঠা {page} / {pages}',
    'admin.emptyTable': 'ইয়াত এতিয়ালৈকে একো নাই।',
    'admin.errorTable': 'ল’ড হোৱা নাই।',
    'admin.status.draft': 'ড্ৰাফ্ট',
    'admin.status.pending_review': 'পৰ্যালোচনাৰ অপেক্ষাত',
    'admin.status.approved': 'অনুমোদিত',
    'admin.status.scheduled': 'সময় নিৰ্ধাৰিত',
    'admin.status.published': 'প্ৰকাশিত',
    'admin.status.archived': 'আৰ্কাইভ',
    'admin.colHeadline': 'শিৰোনাম',
    'admin.colStatus': 'অৱস্থা',
    'admin.colLanguage': 'ভাষা',
    'admin.colPublished': 'প্ৰকাশিত',
    'admin.colUpdated': 'সালসলনি',
    'admin.colViews': 'পঠন',
    'admin.colTranslation': 'অনুবাদ',
    'admin.noTranslation': 'অনুবাদ নাই',
    'admin.createTranslation': '+ অনুবাদ কৰক',
    'admin.publishedAt': 'প্ৰকাশৰ তাৰিখ আৰু সময়',
    'admin.publishedAtHint': 'প্ৰকাশৰ সময় সালসলনি বা পূৰ্ব তাৰিখ নিৰ্ধাৰণ কৰক।',
    'admin.linkTranslation': 'পুৰণি প্ৰবন্ধ সংযোগ কৰক',
    'admin.unlinkTranslation': 'সংযোগ বিচ্ছিন্ন কৰক',
    'admin.unlinkTranslationConfirm': 'আপুনি এই অনুবাদ সংযোগ বিচ্ছিন্ন কৰিবলৈ নিশ্চিতনে?',
    'admin.counterpartArticleId': 'অনুবাদ প্ৰবন্ধৰ ID',
    'admin.linkAction': 'অনুবাদ সংযোগ কৰক',
    'admin.bulkPublish': 'প্ৰকাশ কৰক',
    'admin.bulkUnpublish': 'আঁতৰাওক',
    'admin.bulkArchive': 'আৰ্কাইভ কৰক',
    'admin.bulkDelete': 'মচক',
    'admin.bulkResult': '{done} টা হ’ল, {failed} টা হোৱা নাই',
    'admin.confirmDelete': '{count} টা বাতৰি মচিব নেকি? সেইবোৰ সকলো স্ক্ৰীনৰ পৰা আঁতৰি যাব।',
    'action.cancel': 'বাতিল',
    'admin.byline': 'লেখক',
    'admin.canonical': 'কেনোনিকেল URL',
    'admin.category': 'শ্ৰেণী',
    'admin.compare': 'তুলনা কৰক',
    'admin.conflictTitle': 'আন কোনোবাই এই বাতৰিটো ছেভ কৰিছে',
    'admin.conflictBody': 'আপোনাৰ লেখা ইয়াতেই আছে। প্ৰয়োজনীয় অংশ কপি কৰি লৈ পুনৰ ল’ড কৰক।',
    'admin.createTag': '“{name}” সৃষ্টি কৰক',
    'admin.currentSide': 'এতিয়া',
    'admin.diffHint': 'ওপৰৰ এডিটৰত বৰ্তমানৰ লেখা আছে — এই সংস্কৰণৰ সৈতে তুলনা কৰক।',
    'admin.district': 'জিলা',
    'admin.editorPlaceholder': 'লিখা আৰম্ভ কৰক…',
    'admin.editorToolbar': 'ফৰমেটিং',
    'admin.embed': 'এম্বেড',
    'admin.embedPrompt': 'YouTube, X, Facebook বা Instagram ৰ URL দিয়ক',
    'admin.embedNotAllowed': 'কেৱল YouTube, X, Facebook আৰু Instagram ৰ লিংকহে অন্তৰ্ভুক্ত কৰিব পাৰি।',
    'admin.editImageCaption': 'বৰ্ণনা আৰু শিৰোনাম',
    'admin.imageAltPrompt': 'ছবিৰ বিকল্প পাঠ (সহজ প্ৰৱেশাধিকাৰ আৰু এছইঅ’ৰ বাবে):',
    'admin.imageCaptionPrompt': 'ছবিৰ শিৰোনাম/কেপশ্বন (ঐচ্ছিক):',
    'admin.articleVideo': 'বাতৰিৰ ভিডিঅ’',
    'admin.articleVideoHint': 'এই বাতৰিটোৰ বাবে ঐচ্ছিক YouTube ভিডিঅ’ URL।',
    'admin.clearVideo': 'ভিডিঅ’ আঁতৰাওক',
    'admin.emptyRevision': 'এই সংস্কৰণত কোনো লেখা নাই।',
    'admin.headline': 'শিৰোনাম',
    'admin.languageImmutable': 'এবাৰ বাছনি কৰিলে সলনি নহয় — অনুবাদ এটা সুকীয়া বাতৰি (§1.15)।',
    'admin.link': 'লিংক',
    'admin.linkPrompt': 'লিংকৰ ঠিকনা (খালী ৰাখিলে লিংক আঁতৰিব)',
    'admin.noActions': 'এই বাতৰিটোত এতিয়া আপোনাৰ বাবে কোনো কাম নাই।',
    'admin.noRevisions': 'এতিয়ালৈকে কোনো সংস্কৰণ নাই।',
    'admin.note': 'লেখকলৈ মন্তব্য',
    'admin.noteRequired': 'বাধ্যতামূলক — লেখকে ইয়াক পঢ়িব।',
    'admin.placement': 'স্থান নিৰ্ধাৰণ',
    'admin.preview': 'পূৰ্বদৰ্শন',
    'admin.readingStats': '{words} শব্দ · {minutes} মিনিটৰ পাঠ',
    'admin.reload': 'পুনৰ ল’ড কৰক',
    'admin.removeTag': 'টেগ আঁতৰাওক',
    'admin.rename': 'নাম সলনি কৰক',
    'admin.renameSlug': 'নতুন স্লাগ',
    'admin.restore': 'এই সংস্কৰণ ওভতাই আনক',
    'admin.revisionDiff': 'সংস্কৰণ #{number}',
    'admin.revisionRestored': 'সংস্কৰণ ওভতাই অনা হ’ল।',
    'admin.revisionSide': 'সংস্কৰণ #{number}',
    'admin.revisions': 'সংস্কৰণসমূহ',
    'admin.save': 'ছেভ কৰক',
    'admin.saveConflict': 'সংঘাত',
    'admin.saved': 'ছেভ হৈছে',
    'admin.savedAt': '{time} ত ছেভ হৈছে',
    'admin.saving': 'ছেভ হৈ আছে…',
    'admin.scheduleFor': 'প্ৰকাশৰ সময়',
    'admin.seo': 'SEO আৰু শ্বেয়াৰ',
    'admin.seoDescription': 'মেটা বিৱৰণ',
    'admin.seoDescriptionHint': 'প্ৰায় ১৫৫ আখৰ। নিদিলে সাৰাংশ ব্যৱহাৰ হ’ব।',
    'admin.seoTitle': 'SEO শিৰোনাম',
    'admin.seoTitleHint': 'নিদিলে মূল শিৰোনাম ব্যৱহাৰ হ’ব।',
    'admin.slug': 'স্লাগ',
    'admin.slugChanged': 'নাম সলনি হ’ল — পুৰণি ঠিকনা এতিয়া ৰিডাইৰেক্ট হ’ব।',
    'admin.slugHint': 'অসমীয়া শিৰোনামৰ বাবেও লেটিন আখৰ (§1.15)।',
    'admin.slugLocked': 'প্ৰকাশৰ পিছত লক হয়। তলত নাম সলনি কৰিলে ৰিডাইৰেক্ট হ’ব।',
    'admin.startWriting': 'লিখা আৰম্ভ কৰক',
    'admin.subheadline': 'উপ-শিৰোনাম',
    'admin.summary': 'সাৰাংশ',
    'admin.table': 'টেবুল',
    'admin.tagPlaceholder': 'টেগ বিচাৰক বা সৃষ্টি কৰক',
    'admin.unsaved': 'ছেভ নোহোৱা সালসলনি',
    'admin.workflowDone': 'এতিয়া {status}।',
    'admin.action.submit': 'পৰ্যালোচনালৈ পঠিয়াওক',
    'admin.action.approve': 'অনুমোদন কৰক',
    'admin.action.reject': 'নাকচ কৰক',
    'admin.action.request_changes': 'সালসলনি বিচাৰক',
    'admin.action.publish': 'প্ৰকাশ কৰক',
    'admin.action.schedule': 'সময় নিৰ্ধাৰণ কৰক',
    'admin.action.unpublish': 'আঁতৰাওক',
    'admin.action.archive': 'আৰ্কাইভ কৰক',
    'admin.action.restore': 'ওভতাই আনক',
    'action.close': 'বন্ধ কৰক',
    'admin.addNew': 'নতুন যোগ কৰক',
    'admin.addStory': 'বাতৰি যোগ কৰক',
    'admin.addStoryPlaceholder': 'প্ৰকাশিত বাতৰি বিচাৰক',
    'admin.addVideo': 'ভিডিঅ’ যোগ কৰক',
    'admin.allTypes': 'সকলো প্ৰকাৰ',
    'admin.altMissing': 'Alt লেখা নাই — এই ছবি বাতৰিত ব্যৱহাৰ কৰিব নোৱাৰি',
    'admin.altRequired': 'বাতৰিত ব্যৱহাৰৰ আগতে বাধ্যতামূলক।',
    'admin.altText': 'Alt লেখা',
    'admin.arrangementSaved': 'প্ৰথম পৃষ্ঠা সালসলনি হ’ল।',
    'admin.autoRotate': 'স্বয়ংক্ৰিয়ভাৱে ঘূৰক',
    'admin.breakingPublished': 'টিকাৰত উঠিল।',
    'admin.caption': 'কেপশ্যন',
    'admin.colour': 'ৰং',
    'admin.confirmRotate': 'ছবিখন ঘূৰাব নে? ফাইলটো পুনৰ লিখা হ’ব আৰু সকলো আকাৰ নতুনকৈ বনোৱা হ’ব।',
    'admin.create': 'সৃষ্টি কৰক',
    'admin.credit': 'কৃতিত্ব',
    'admin.culture': 'সংস্কৃতি বিশেষ',
    'admin.cultureSupport': 'সংস্কৃতি — সহায়ক বাতৰি',
    'admin.edit': 'সম্পাদনা',
    'admin.editingLanguage': 'সম্পাদনা কৰি আছে',
    'admin.expired': 'শেষ',
    'admin.externalUrl': 'বা বাহিৰৰ লিংক',
    'admin.hero': 'হিৰ’ কেৰাচেল',
    'admin.icon': 'আইকন',
    'admin.iconHint': 'আইকন ছেটৰ এটা নাম, যেনে sports, culture।',
    'admin.keyUpdate': 'মুখ্য আপডেট',
    'admin.linkStory': 'বাতৰি সংযোগ কৰক',
    'admin.livePreview': 'জীৱন্ত পূৰ্বদৰ্শন',
    'admin.mediaDeleteRefused': '{count} টা এতিয়াও ব্যৱহৃত, ৰখা হ’ল।',
    'admin.mediaDeleted': 'মচা হ’ল।',
    'admin.mediaSaved': 'ছবিৰ তথ্য ছেভ হ’ল।',
    'admin.mediaTransformed': 'ছবি পুনৰ লিখা হ’ল।',
    'admin.mediaType': 'প্ৰকাৰ',
    'admin.minutesLeft': '{minutes} মিনিট বাকী',
    'admin.moveDown': 'তললৈ নিয়ক',
    'admin.moveUp': 'ওপৰলৈ নিয়ক',
    'admin.name': 'নাম',
    'admin.newLiveEvent': 'নতুন লাইভ ইভেণ্ট',
    'admin.newUpdate': 'নতুন আপডেট',
    'admin.noPins': 'একো পিন কৰা নাই — ট্ৰেণ্ডিং গণনা কৰা হয়।',
    'admin.pickEvent': 'আপডেট দিবলৈ এটা ইভেণ্ট বাছনি কৰক।',
    'admin.post': 'পোষ্ট কৰক',
    'admin.postShortcut': 'Ctrl/⌘ + Enter ত পোষ্ট হয়',
    'admin.priority': 'প্ৰাথমিকতা',
    'admin.publishNow': 'এতিয়াই প্ৰকাশ কৰক',
    'admin.publishVideo': 'প্ৰকাশ কৰক',
    'admin.ranked': 'ৰেংকড স্তম্ভ',
    'admin.refresh': 'সতেজ কৰক',
    'admin.remove': 'আঁতৰাওক',
    'admin.rotate': '৯০° ঘূৰাওক',
    'admin.rotationSeconds': 'ছেকেণ্ড',
    'admin.runsForHint': 'সেই সময়ত টিকাৰৰ পৰা নিজেই আঁতৰি যাব।',
    'admin.runsForMinutes': 'কিমান মিনিট চলিব',
    'admin.saveOrder': 'ক্ৰম ছেভ কৰক',
    'admin.searchMedia': 'ফাইলৰ নাম আৰু কেপশ্যন বিচাৰক',
    'admin.sections': 'খণ্ডসমূহ',
    'admin.slotEmpty': 'ইয়াত এতিয়ালৈকে একো নাই।',
    'admin.slugDerived': 'ঠিকনা ইংৰাজী নামৰ পৰা বনোৱা হয় আৰু একক ৰখা হয়।',
    'admin.source': 'উৎস',
    'admin.statusChanged': 'অৱস্থা সলনি হ’ল।',
    'admin.takeDown': 'নমাই দিয়ক',
    'admin.trendingHint': 'পিন কৰা বাতৰি গণনাতকৈ ওপৰত থাকে আৰু কেতিয়াও সলনি নহয়।',
    'admin.trendingPins': 'ট্ৰেণ্ডিং পিন',
    'admin.typeDocument': 'নথি',
    'admin.typeImage': 'ছবি',
    'admin.unpublishVideo': 'আঁতৰাওক',
    'admin.usageHint': 'কোনো বাতৰিয়ে এই ছবি ব্যৱহাৰ কৰি থাকিলে মচা নহ’ব।',
    'admin.videoAdded': 'ভিডিঅ’ যোগ হ’ল।',
    'admin.delete': 'বিলোপ কৰক',
    'admin.inactive': 'নিষ্ক্ৰিয়',
    'admin.confirmDeleteTaxonomy': 'আপুনি নিশ্চিতনে এইটো বিলোপ কৰিব বিচাৰে?',
    'admin.deleteTaxonomyTitle': '“{name}” বিলোপ কৰিবনে?',
    'admin.deleteTaxonomyTagWarning': 'এই টেগটো স্থায়ীভাৱে বিলোপ কৰা হ’ব আৰু সকলো বাতৰিৰ পৰা আঁতৰাই দিয়া হ’ব।',
    'admin.deleteTaxonomyCategoryWarning': 'এই শ্ৰেণীটো বিলোপ কৰা হ’ব। কোনো প্ৰকাশিত বাতৰিত ই ব্যৱহৃত হৈ থকা নাই বুলি নিশ্চিত হওক।',
    'admin.deleteTaxonomyDistrictWarning': 'এই জিলাখন বিলোপ কৰা হ’ব।',
    'admin.deleteTaxonomyAuthorWarning': 'যদি এই লেখকৰ বাতৰি আছে, বাইলাইন সংৰক্ষণৰ বাবে তেওঁক নিষ্ক্ৰিয় কৰা হ’ব। যদি বাতৰি নাই, স্থায়ীভাৱে বিলোপ কৰা হ’ব।',
    'admin.filterTaxonomy': 'নাম বা ঠিকনাৰে ফিল্টাৰ কৰক…',
    'admin.noMatchingTaxonomy': 'সন্ধানৰ সৈতে কোনো বস্তু মিল খোৱা নাই।',
    'admin.clearFilter': 'ফিল্টাৰ পৰিষ্কাৰ কৰক',
    'admin.itemDeleted': 'বিলোপ কৰা হ’ল।',
    'admin.authorDeactivated': 'লেখক নিষ্ক্ৰিয় কৰা হ’ল (পুৰণি বাতৰিৰ বাইলাইন সুৰক্ষিত)।',
    'admin.authorReactivated': 'লেখক পুনৰ সক্ৰিয় কৰা হ’ল।',
    'admin.editVideo': 'ভিডিঅ’ সম্পাদনা',
    'admin.deleteVideo': 'ভিডিঅ’ বিলোপ কৰক',
    'admin.confirmDeleteVideo': 'আপুনি নিশ্চিতনে এই ভিডিঅ’টো বিলোপ কৰিব খোজে? ই সকলো ফিডৰ পৰা আঁতৰি যাব।',
    'admin.videoUpdated': 'ভিডিঅ’ নবীকৰণ কৰা হ’ল।',
    'admin.videoDeleted': 'ভিডিঅ’ বিলোপ কৰা হ’ল।',
    'admin.videoDescription': 'বিৱৰণ',
    'admin.durationSeconds': 'সময়সীমা (ছেকেণ্ড)',
    'admin.videoResolved': '{source} · {id} বুলি চিনাক্ত হ’ল',
    'admin.videoTitle': 'শিৰোনাম',
    'admin.videoUrl': 'ভিডিঅ’ৰ URL',
    'admin.viewLive': 'লাইভ পৃষ্ঠা চাওক',
    'admin.topStory': 'শীৰ্ষ বাতৰি',
    'admin.topStoryBadge': 'শীৰ্ষ',
    'admin.makeTopStory': 'শীৰ্ষ কৰক',
    'admin.topStoryHint': 'এই ভাষাৰ মুখ্য পৃষ্ঠাত আগত থাকিব। ইয়াত নিৰ্বাচন কৰিলে বৰ্তমানৰ শীৰ্ষ বাতৰিটো নামি যাব।',
    'admin.topStoryWhenPublished': 'এই বাতৰিটো প্ৰকাশ হোৱাৰ লগে লগে মুখ্য পৃষ্ঠাত আগত থাকিব।',
    'admin.topStorySet': 'এতিয়া মুখ্য পৃষ্ঠাৰ শীৰ্ষ বাতৰি।',
    'admin.topStoryCleared': 'আৰু শীৰ্ষ বাতৰি নহয়।',
    'admin.featuredImage': 'মুখ্য ছবি',
    'admin.chooseImage': 'ছবি বাছনি কৰক',
    'admin.replaceImage': 'সলনি কৰক',
    'admin.removeImage': 'আঁতৰাওক',
    'admin.insertImage': 'ছবি',
    'admin.upload': 'আপলোড',
    'admin.uploadDone': 'আপলোড হ’ল।',
    'admin.uploadFailed': '{count} টা আপলোড হোৱা নাই।',
    'admin.mediaEmpty': 'এতিয়ালৈকে ছবি নাই — আপলোড কৰক বা ইয়াত টানি আনক।',
    'admin.useImage': 'এই ছবিখন ব্যৱহাৰ কৰক',
    'admin.saveAltText': 'বিকল্প লিখনি ৰাখক',
    'admin.chooseSocialImage': 'শ্বেয়াৰৰ ছবি বাছনি কৰক',
    'admin.replaceSocialImage': 'শ্বেয়াৰৰ ছবি সলনি কৰক',
    'admin.useFeaturedImage': 'মুখ্য ছবিখন ব্যৱহাৰ কৰক',
    'admin.section.top_story': 'শীৰ্ষ বাতৰি',
    'admin.section.hero': 'হিৰ’',
    'admin.section.ranked': 'ৰেংকড',
    'admin.section.categories': 'শ্ৰেণীসমূহ',
    'admin.section.latest': 'শেহতীয়া',
    'admin.section.trending': 'চৰ্চাত',
    'admin.section.culture': 'সংস্কৃতি',
    'admin.section.live': 'লাইভ',
    'admin.section.videos': 'ভিডিঅ’',
    'admin.section.newsletter': 'নিউজলেটাৰ',
    'admin.section.ad': 'বিজ্ঞাপন',
    'admin.breakingStatus.scheduled': 'সময় নিৰ্ধাৰিত',
    'admin.breakingStatus.active': 'লাইভ',
    'admin.breakingStatus.expired': 'শেষ',
    'admin.breakingStatus.archived': 'আৰ্কাইভ',
    'admin.liveStatus.scheduled': 'সময় নিৰ্ধাৰিত',
    'admin.liveStatus.live': 'লাইভ',
    'admin.liveStatus.ended': 'শেষ',
    'admin.liveStatus.archived': 'আৰ্কাইভ',
    'admin.role': 'ভূমিকা',
    'admin.roleMatrix': 'ভূমিকা আৰু অনুমতি',
    'admin.roleMatrixHint': 'কেৱল পঢ়িবলৈ: এই মেপ ক’ডত থাকে (§1.4), ডাটাবেছে তাকে প্ৰতিফলিত কৰে।',
    'admin.permission': 'অনুমতি',
    'admin.newUser': 'নতুন ব্যৱহাৰকাৰী',
    'admin.userCreated': 'একাউণ্ট সৃষ্টি হ’ল। অস্থায়ী পাছৱৰ্ড দিয়ক।',
    'admin.temporaryPassword': 'অস্থায়ী পাছৱৰ্ড',
    'admin.temporaryPasswordHint': 'কমেও ১২ আখৰ। প্ৰথম লগ ইনতে সলনি কৰিব লাগিব।',
    'admin.forceReset': 'পাছৱৰ্ড ৰিছেট',
    'admin.forceResetBody': 'সকলো ছেছন লগে লগে শেষ হ’ব আৰু লগ ইনত নতুন পাছৱৰ্ড দিব লাগিব।',
    'admin.resetDone': 'পাছৱৰ্ড ৰিছেট আৰু ছেছন শেষ হ’ল।',
    'admin.revokeSessions': 'ছেছন শেষ কৰক',
    'admin.sessionsRevoked': 'ছেছন শেষ হ’ল।',
    'admin.sessions': 'ছেছন',
    'admin.lastLogin': 'শেষ লগ ইন',
    'admin.deactivate': 'নিষ্ক্ৰিয় কৰক',
    'admin.reactivate': 'পুনৰ সক্ৰিয় কৰক',
    'admin.confirmDeactivate': 'এই একাউণ্ট নিষ্ক্ৰিয় কৰিব নে? ছেছনসমূহ লগে লগে শেষ হ’ব।',
    'admin.userStatus.active': 'সক্ৰিয়',
    'admin.userStatus.invited': 'আমন্ত্ৰিত',
    'admin.userStatus.suspended': 'স্থগিত',
    'admin.userStatus.deactivated': 'নিষ্ক্ৰিয়',
    'admin.myProfile': 'মোৰ প্ৰফাইল',
    'admin.profileSubtitle': 'আপোনাৰ ব্যক্তিগত তথ্য, ইমেইল ঠিকনা আৰু একাউণ্টৰ সুৰক্ষা পৰিচালনা কৰক।',
    'admin.editUser': 'ব্যৱহাৰকাৰী সম্পাদনা',
    'admin.editUserSubtitle': 'একাউণ্টৰ তথ্য, ভূমিকা, স্থিতি বা নতুন পাছৱৰ্ড সলনি কৰক।',
    'admin.changePassword': 'পাছৱৰ্ড সলনি কৰক',
    'admin.currentPassword': 'বৰ্তমানৰ পাছৱৰ্ড',
    'admin.newPassword': 'নতুন পাছৱৰ্ড',
    'admin.confirmNewPassword': 'নতুন পাছৱৰ্ড নিশ্চিত কৰক',
    'admin.passwordMismatch': 'নতুন পাছৱৰ্ড দুটা মিল খোৱা নাই',
    'admin.passwordMinLength': 'পাছৱৰ্ড কমেও ৮টা আখৰ হ’ব লাগিব',
    'admin.profileUpdated': 'প্ৰফাইল নবীকৰণ হ’ল।',
    'admin.passwordChanged': 'পাছৱৰ্ড সফলতাৰে সলনি কৰা হ’ল।',
    'admin.userUpdated': 'ব্যৱহাৰকাৰী সফলতাৰে নবীকৰণ হ’ল।',
    'admin.setPasswordHint': 'পুৰণি পাছৱৰ্ড ৰাখিবলৈ খালী ৰাখক, বা কমেও ৮টা আখৰ লিখক',
    'admin.activeSessions': 'সক্ৰিয় ছেছন',
    'admin.preferredLanguage': 'পছন্দৰ ভাষা',
    'admin.accountSecurity': 'একাউণ্ট সুৰক্ষা',
    'admin.siteSettings': 'ছাইট',
    'admin.seoSettings': 'SEO ডিফল্ট',
    'admin.defaultTitle': 'ডিফল্ট শিৰোনাম',
    'admin.titleTemplate': 'শিৰোনামৰ টেমপ্লেট',
    'admin.titleTemplateHint': 'যেনে {title} — NK নিউজ টাইম',
    'admin.defaultDescription': 'ডিফল্ট বিৱৰণ',
    'admin.organisation': 'প্ৰতিষ্ঠানৰ নাম',
    'admin.twitterSite': 'X / Twitter হেণ্ডেল',
    'admin.robots': 'Robots নিৰ্দেশ',
    'admin.robotsHint': 'যেনে index, follow — ফেজ ১৫ এ ইয়াক প্ৰতিটো পৃষ্ঠাত লিখিব।',
    'admin.googleVerification': 'Google ভেৰিফিকেশ্যন',
    'admin.bingVerification': 'Bing ভেৰিফিকেশ্যন',
    'admin.when': 'কেতিয়া',
    'admin.actor': 'কোনে',
    'admin.actionColumn': 'কাম',
    'admin.actionPrefix': 'article. …',
    'admin.entity': 'বিষয়',
    'admin.allEntities': 'সকলো',
    'meta.searchDescription': 'NK News Time-ৰ প্ৰকাশিত সকলো বাতৰি বিচাৰক — শ্ৰেণী, জিলা, প্ৰতিবেদক বা তাৰিখ অনুসৰি, অসমীয়া আৰু ইংৰাজী দুয়োটাতে।',
    'meta.trendingDescription': 'এই মুহূৰ্তত অসমে পঢ়ি থকা বাতৰিসমূহ — পাঠকে যি খোলে, সম্পূৰ্ণ পঢ়ে আৰু শ্বেয়াৰ কৰে তাৰ ভিত্তিত।',
    'meta.videosDescription': 'অসমৰ চুকে-কোণে ভূমি প্ৰতিবেদন, সাক্ষাৎকাৰ আৰু বুলেটিন — NK News Time ভিডিঅ’ ডেস্ক।',
    'meta.liveDescription': 'NK News Time-ৰ পোনপটীয়া সম্প্ৰচাৰ: বিধানসভা অধিবেশন, নিৰ্বাচনী গণনা, বানপানী আৰু প্ৰতি মিনিটত সলনি হোৱা সকলো।',
    'meta.newsletterDescription': 'অসমৰ দিনটো, আপোনাৰ ইনবক্সত। NK News Time বাতৰি কক্ষৰ পৰা বিনামূলীয়া দৈনিক সাৰাংশ।',
    'meta.localDescription': 'অসমৰ জিলাসমূহৰ বাতৰি — স্থানীয়ভাৱে, তাতেই থকা প্ৰতিবেদকৰ দ্বাৰা।',
    'meta.categoryDescription': 'অসম আৰু ইয়াৰ বাহিৰৰ {name} বাতৰি, NK News Time-ৰ প্ৰতিবেদন।',
    'meta.tagDescription': '{name} টেগ কৰা NK News Time-ৰ সকলো বাতৰি, নতুনটোৰ পৰা।',
    'meta.authorDescription': '{name}-ৰ NK News Time-ৰ বাবে লিখা বাতৰিসমূহ।',
    // --- Measurement notice (Phase 16) -----------------------------------------
    'consent.title': 'পৰিমাপ',
    'consent.body': 'কোনবোৰ বাতৰি পঢ়া হৈছে সেয়া আমি গণনা কৰোঁ, যাতে সম্পাদকীয় বিভাগে জানিব পাৰে কি গুৰুত্বপূৰ্ণ। কুকি নাই, বিজ্ঞাপনৰ ট্ৰেকাৰ নাই, আপোনাক চিনাক্ত কৰা একোৱেই নাই।',
    'consent.accept': 'অনুমতি দিয়ক',
    'consent.decline': 'নালাগে',
    // --- Analytics (PRD §25) ----------------------------------------------------
    'admin.analytics': 'বিশ্লেষণ',
    'admin.analytics.overview': 'সাৰাংশ',
    'admin.analytics.content': 'বিষয়বস্তু',
    'admin.analytics.video': 'ভিডিঅ’',
    'admin.analytics.advertising': 'বিজ্ঞাপন',
    'admin.analytics.search': 'সন্ধান',
    'admin.analytics.visitors': 'দৰ্শক',
    'admin.analytics.visitorsHint': 'প্ৰতিদিনে নতুনকৈ গণনা কৰা হয়। কাইলৈ পুনৰ আহিলে সেই পাঠক দুবাৰ গণনা হয় — চিনাক্তকাৰী প্ৰতি ৰাতি সলনি হয় আৰু এদিনৰ পৰা আন দিনলৈ ৰখা নহয়।',
    'admin.analytics.sessions': 'ছেছন',
    'admin.analytics.pageViews': 'পৃষ্ঠা দৰ্শন',
    'admin.analytics.pagesPerSession': 'প্ৰতি ছেছনত পৃষ্ঠা',
    'admin.analytics.trend': 'দৰ্শক আৰু পৃষ্ঠা দৰ্শন',
    'admin.analytics.sources': 'ট্ৰেফিকৰ উৎস',
    'admin.analytics.devices': 'ডিভাইচ',
    'admin.analytics.countries': 'দেশ',
    'admin.analytics.topPages': 'জনপ্ৰিয় পৃষ্ঠা',
    'admin.analytics.articleViews': 'বাতৰি দৰ্শন',
    'admin.analytics.avgReadTime': 'গড় পঢ়াৰ সময়',
    'admin.analytics.shares': 'শ্বেয়াৰ',
    'admin.analytics.mostRead': 'সৰ্বাধিক পঠিত',
    'admin.analytics.mostShared': 'সৰ্বাধিক শ্বেয়াৰ',
    'admin.analytics.popularCategories': 'জনপ্ৰিয় শ্ৰেণী',
    'admin.analytics.popularDistricts': 'জনপ্ৰিয় জিলা',
    'admin.analytics.finished': 'সম্পূৰ্ণ পঢ়া',
    'admin.analytics.plays': 'প্লে',
    'admin.analytics.watchTime': 'চোৱাৰ সময়',
    'admin.analytics.completionRate': 'সম্পূৰ্ণ চোৱাৰ হাৰ',
    'admin.analytics.impressions': 'ইম্প্ৰেছন',
    'admin.analytics.clicks': 'ক্লিক',
    'admin.analytics.ctr': 'CTR',
    'admin.analytics.campaigns': 'কেম্পেইন অনুসৰি',
    'admin.analytics.placements': 'প্লেচমেণ্ট অনুসৰি',
    'admin.analytics.adsPending': 'বিজ্ঞাপনৰ ক্ৰিয়েটিভ ফেজ ১৩-ত পৰিৱেশন হ’ব। তেতিয়ালৈকে এই সংখ্যাবোৰ শুদ্ধ, কিন্তু খালী।',
    'admin.analytics.searches': 'সন্ধান',
    'admin.analytics.zeroResultRate': 'একো পোৱা নগ’ল',
    'admin.analytics.topQueries': 'শীৰ্ষ সন্ধান',
    'admin.analytics.zeroQueries': 'একো ফল নোপোৱা সন্ধান',
    'admin.analytics.zeroQueriesHint': 'পাঠকে যি বিচাৰিলে অথচ নাপালে — বাতৰিৰ খালী ঠাইৰ আটাইতকৈ স্পষ্ট ইংগিত।',
    'admin.analytics.query': 'সন্ধানৰ শব্দ',
    'admin.analytics.avgResults': 'গড় ফল',
    'admin.analytics.timesSearched': 'সন্ধান কৰা হ’ল',
    'admin.analytics.range7': 'যোৱা ৭ দিন',
    'admin.analytics.range28': 'যোৱা ২৮ দিন',
    'admin.analytics.range90': 'যোৱা ৯০ দিন',
    'admin.analytics.rangeCustom': 'নিজৰ পছন্দ',
    'admin.analytics.from': 'পৰা',
    'admin.analytics.to': 'লৈ',
    'admin.analytics.compare': 'আগৰ সময়ছোৱাৰ সৈতে তুলনা',
    'admin.analytics.comparedWith': 'আগতে {value}',
    'admin.analytics.exportCsv': 'CSV ৰপ্তানি',
    'admin.analytics.allLanguages': 'দুয়োটা সংস্কৰণ',
    'admin.analytics.noData': 'এই সময়ছোৱাত এতিয়ালৈকে একো নথিভুক্ত হোৱা নাই।',
    'admin.analytics.freshness': 'প্ৰতি দহ মিনিটত সংখ্যা সতেজ হয়।',
    'admin.analytics.device.mobile': 'ম’বাইল',
    'admin.analytics.device.tablet': 'টেবলেট',
    'admin.analytics.device.desktop': 'ডেস্কটপ',
    'admin.analytics.direct': 'পোনপটীয়া',
    'admin.analytics.unknown': 'অজ্ঞাত',
    'admin.analytics.page': 'পৃষ্ঠা',
    'admin.analytics.views': 'দৰ্শন',
    'admin.analytics.headline': 'শিৰোনাম',
    'admin.analytics.videoTitle': 'ভিডিঅ’',
    'admin.analytics.campaign': 'কেম্পেইন',
    'admin.analytics.placement': 'প্লেচমেণ্ট',
    'admin.analytics.shareOfTotal': 'অংশ',
    'admin.analytics.seconds': '{value} ছেকেণ্ড',
};
//# sourceMappingURL=as.js.map